// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2ZBTJ","col":"styles_col__Mlr-J","fulfillmentStatus":"styles_fulfillmentStatus__1S6kR","emailCol":"styles_emailCol__3gVHj"};